import React from 'react';
import styled from 'styled-components';
import Image from './Image';
import Label from './Label';
import { NotificationWrapper as GrowlWrapper, NotificationCloseComponent, PageNotificationColorCode, SubText } from './PageNotification';
import { DashNotificationsModule } from '../modules';
import { DateTimeUtils } from '../utils';
const UserNotificationComponent = ({ notification, isDismissButtonEnabled, onClickDismiss }) => {
    const renderDate = (dateString) => {
        const date = DateTimeUtils.parseDate(dateString, 'yyyy-MM-dd HH:mm');
        let formattedDateString = DateTimeUtils.formatDate(date, 'DD, HH:mm');
        if (DateTimeUtils.diff(DateTimeUtils.getUtcNow(), date) < 1) {
            formattedDateString = 'Today, ' + DateTimeUtils.formatDate(date, 'HH:mm');
        }
        else if (DateTimeUtils.diff(DateTimeUtils.getUtcPreviousDay(1), date) < 2) {
            formattedDateString = 'Yesterday, ' + DateTimeUtils.formatDate(date, 'HH:mm');
        }
        return formattedDateString + ' UTC';
    };
    return notification.isGrowl ?
        React.createElement(GrowlWrapper, { colorCode: PageNotificationColorCode.LIGHT_BLUE, hideMargin: true },
            React.createElement(SubText, null,
                React.createElement(ContentLabel, { text: notification.content }),
                React.createElement(LinkLabel, { text: notification.ctaLabel, onClick: () => window.open(notification.ctaUrl) })),
            React.createElement(NotificationCloseComponent, { onClick: () => { }, "data-testid": 'pageNotification_closeBtn' }, "\u2715")) :
        React.createElement(NotificationWrapper, null,
            React.createElement(NotificationTitleWrapper, null,
                React.createElement(RowWrapper, null,
                    React.createElement(Image, { src: DashNotificationsModule.utils.NotificationTypeUtils.getRelatedProductImage(notification), alt: notification.relatedProduct, width: notification.relatedProduct === 'system' ? 20 : 16, height: notification.relatedProduct === 'system' ? 20 : 16 }),
                    React.createElement(RelatedProductLabel, { text: DashNotificationsModule.utils.NotificationTypeUtils.getRelatedProductName(notification) })),
                React.createElement(DismissNotificationButton, { onClick: () => {
                        if (isDismissButtonEnabled && onClickDismiss)
                            onClickDismiss(notification);
                    } }, "\u2715")),
            React.createElement(ContentWrapper, null,
                React.createElement(ContentLabel, { text: notification.content }),
                React.createElement(LinkLabel, { text: notification.ctaLabel, onClick: () => window.open(notification.ctaUrl) })),
            React.createElement(RowWrapper, null,
                React.createElement(CreatedAtLabel, { text: renderDate(notification.createdAt) })));
};
export default UserNotificationComponent;
const NotificationWrapper = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid rgb(224, 226, 230);
    background-color: ${props => props.theme.colors.white};
    overflow-wrap: anywhere;
`;
const RowWrapper = styled.div `
    display: flex;
    padding-top: 5px;
    padding-bottom: 5px;
    align-items: center;
    text-align: left;
`;
const ContentWrapper = styled.div `
    display: inline;
    padding-top: 5px;
    padding-bottom: 5px;
    align-items: center;
    text-align: left;
`;
const NotificationTitleWrapper = styled.div `
    display: flex;
    justify-content: space-between;
`;
const ContentLabel = styled(Label) `
    display: inline;
    padding-right: 5px;
    font-size: 14px;
`;
const RelatedProductLabel = styled(Label) `
    display: inline;
    padding-left: 10px;
    font-size: 11px;
`;
const LinkLabel = styled(Label) `
    font-family: ${props => props.theme.fonts.medium};
    font-size: 14px;
    color: ${props => props.theme.colors.anchorText};

    text-decoration: none;
    cursor: pointer;
    display: inline;
`;
const DismissNotificationButton = styled.span `
    font-family: ${props => props.theme.fonts.regular};
    font-size: 14px;
    color: ${props => props.theme.colors.grayLight};
    cursor: pointer;
    line-height: 34px;
    align-self: center;
    cursor: pointer;
`;
const CreatedAtLabel = styled(Label) `
    font-size: 11px;
    color: #808d98;
`;
//# sourceMappingURL=UserNotificationComponent.js.map